export const AUTOMATION_TRIGGER_TYPES: Record<string, StartDateTriggeredCommunicationTriggerType> =
  Object.freeze({
    START_DATE: 'START_DATE',
    BIRTHDATE: 'BIRTHDATE',
  });
